import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import { useTranslationContext } from '../../../../hooks/translations/translationsProvider';
import { GREEN_LOGO, GREEN_MAIN, WHITE } from '../../../../theme/colors';

interface ActionDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    content: string;
    amount: string;
    user: string;
}

const ActionDialog: React.FC<ActionDialogProps> = ({ open, onClose, onConfirm, title, content, amount, user }) => {
  const { t } = useTranslationContext();
  
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        sx: {
          border: `1px solid ${GREEN_MAIN}`,
          borderRadius: '5px',
        }
      }}
    >
      <DialogTitle 
        sx={{ 
          color: GREEN_MAIN,
          fontSize: '1.2rem',
          textAlign: 'center',
          fontWeight: 'bold'
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent sx={{ color: GREEN_MAIN }}>
        {content}
      </DialogContent>
      <DialogContent sx={{ color: GREEN_MAIN, paddingBottom: '0px'}}>
        {t("Utente")}: {user}
      </DialogContent>
      <DialogContent sx={{ color: GREEN_MAIN, paddingTop: '0px', paddingBottom: '35px'}}>
        {t("Importo")}: {amount}
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          sx={{
            backgroundColor: GREEN_LOGO,
            color: WHITE,
            border: `1px solid ${GREEN_LOGO}`,
            '&:hover': {
              backgroundColor: 'darkgreen',
              border: '1px solid darkgreen',
            }
          }}
        >
          {t("Annulla")}
        </Button>
        <Button 
          onClick={onConfirm} 
          sx={{
            backgroundColor: GREEN_LOGO,
            color: WHITE,
            border: `1px solid ${GREEN_LOGO}`,
            '&:hover': {
              backgroundColor: 'darkgreen',
              border: '1px solid darkgreen',
            }
          }}
        >
          {t("Conferma")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActionDialog;

